export const proxyModelMixin = {
    props: {
        modelValue: {
            type: [String, Number, Object],
        },
    },
    emits: ['update:modelValue'],
    computed: {
        model: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
};
